// import React, { useEffect, useMemo, useRef, useState } from 'react';
// import useSearchMember from '../../../../hooks/fetchUsers';
// import { Tooltip, OverlayTrigger } from "react-bootstrap";
// import { CustomInputSearch } from '../../../dashboard/subContent/searchContainer/CustomInputSearch';
// import { AnimatePresence, motion } from 'framer-motion';
// import logger from '../../../../utils/logger';
// import { useSelector } from 'react-redux';
// import { useForm } from 'react-hook-form';
// import { MemberService } from '../../../../services/MemberService';

// export const ActiveSearchComponent = ({ url, handleData, searchSchema, showSearchBtn, activeTab, initialData }) => {
//   const selectListOptions = useSelector(data => data.commonData.lista.formationPlaces);

//   const [isVisible, setIsVisible] = useState(true);
//   const [cleanEnable, setCleanEnable] = useState(false);

//   const [activeFilter, setActiveFilter] = useState({});

//   const { register, handleSubmit, reset, watch } = useForm();
//   const allValues = watch();

//   logger.debug('allValues: ', allValues)


//   const [renderUsers, setRenderUsers] = useState([])



//   useEffect(() => {
//     // 👉 Caso 1: se pasan los datos a buscar
//     if (Array.isArray(initialData)) {
//       setRenderUsers({ items: initialData })
//       return;
//     }

//     // 👉 Caso 2: hay que ir a la API
//     if (!url) return

//     const fetchUsers = async () => {
//       const params = {
//         PageSize: 10,
//         PageIndex: 1,
//         Filter: activeTab ? "Active" : "Inactive"
//       };

//       try {
//         const response = await MemberService.getMembers(params, url);
//         setRenderUsers(response.data);
//       } catch (err) {
//         logger.error(err);
//       }
//     };

//     fetchUsers();
//   }, [activeTab, url, initialData])


//   logger.debug('renderUsers: ', renderUsers)

//   const users = useMemo(() => renderUsers?.items || [], [renderUsers]);

//   //?Debounce 

//   const [debouncedValues, setDebouncedValues] = useState({})

//   useEffect(() => {
//     const timer = setTimeout(() => {
//       setDebouncedValues(prev => ({
//         ...prev,

//         name: allValues.name
//       }));
//     }, 300);

//     return () => clearTimeout(timer);
//   }, [allValues.name]);


//   //? Filtrado memorizado
//   const filteredUsers = useMemo(() => {
//     if (!users.length) return [];

//     const isEmpty = Object.values(allValues).every(val => val === "" || val === "0");
//     if (isEmpty) return users;

//     return users.filter(item =>
//       (allValues.formationPlace
//         ? item.formationPlace?.id === Number(allValues.formationPlace)
//         : true) &&
//       item.name?.toLowerCase().includes(debouncedValues.name?.toLowerCase() || "")
//     )
//   }, [users, allValues, debouncedValues.name])

//   //? Enviar al padre solo si cambia realmente
//   useEffect(() => {
//     handleData(prev => {
//       const prevItems = prev?.items || [];
//       const areEqual =
//         prevItems.length === filteredUsers.length &&
//         prevItems.every((u, i) => u.id === filteredUsers[i].id);

//       if (!areEqual) {
//         logger.debug('Nuevo array filter: ', filteredUsers);
//         return { items: filteredUsers };
//       }
//       return prev;
//     });
//   }, [filteredUsers, handleData]);


//   //? Control del botón limpiar
//   useEffect(() => {
//     const hasValues = Object.values(allValues).some(val => val !== "" && val !== "0");
//     setCleanEnable(hasValues);
//   }, [allValues]);

//   const searchRef = useRef(null);

//   const toggleSearch = () => setIsVisible(prev => !prev);


//   //?Efecto para cerrar el buscador cuando se hace click fuera de el
//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       // if (searchRef.current && !searchRef.current.contains(event.target)) {
//       //   setIsVisible(false)
//       // }
//     };

//     document.addEventListener('mousedown', handleClickOutside)

//     return () => {
//       document.removeEventListener('mousedown', handleClickOutside)
//     }
//   }, [])

//   const onSubmit = (data) => {
//     logger.info('data: ', data);
//   };

//   const onClean = (data) => {
//     const emptyValues = Object.fromEntries(
//       Object.keys(data).map(key => [key, key === "FormationPlaceId" ? "0" : ""])
//     );
//     reset(emptyValues);
//   };

//   return (
//     <div className={`search active-search-container ${isVisible && 'searchMobileStyle'}`} ref={searchRef}>
//       <div className="buttons-searchers-containers d-flex">
//         {cleanEnable && !isVisible &&
//           <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-top">Limpiar búsqueda</Tooltip>}>
//             <button
//               id="btnCleanAdvancedSearch"
//               type='button'
//               className="btn btn-link color-gray decoration-none d-flex align-items-center me-2 query-margin"
//               onClick={handleSubmit(onClean)}
//             >
//               <span className="icon-trash">
//                 <i className="bi bi-trash3 outline trashClass"></i>
//                 <i className="bi bi-trash3-fill fill trashClass"></i>
//               </span>
//             </button>
//           </OverlayTrigger>
//         }

//         {/* <div className="btn-Asearch">
//           <div className='advanced-search-container d-flex p-2' onClick={toggleSearch}>
//             <span>Busqueda Avanzada</span>
//             <span className={`material-symbols-outlined mI-arrow ${isVisible && 'arrow-subClass'}`}>
//               keyboard_double_arrow_up
//             </span>
//           </div>
//         </div> */}
//       </div>


//       {isVisible &&
//         <div className="d-flex w-100">
//           <form
//             className="aSearch-container formation-search-form"
//             onSubmit={handleSubmit(onSubmit)}
//             onKeyDown={(e) => {
//               //👉 Si el usuario presiona Enter en cualquier input, select, react-select, creatable, etc → NO envía el formulario
//               //👉 Enter en textarea sí funciona por los saltos de línea
//               if (e.key === "Enter") {
//                 e.preventDefault();
//               }
//             }}
//           >



//             {searchSchema && searchSchema.map((i) => {


//               if (i.hasOwnProperty("select") && i.select === 'true') {
//                 return (selectListOptions && selectListOptions.length > 0 &&

//                   <div className="form-floating form-aSearch" key={i.id}>

//                     <select
//                       {...register(i.name)}
//                       id={i.name}
//                       name={i.name}
//                       className="form-select pt-0 formation-selects"
//                       defaultValue=""
//                     >

//                       <option value="" disabled hidden>
//                         Selecciona una opción
//                       </option>

//                       {selectListOptions.map((option, index) => {

//                         return <option key={index} value={option.id}> {option.name}</option>
//                       })

//                       }
//                     </select>

//                     <label className="label-fButtons" htmlFor={i.name}>{i.labelTitle}</label>
//                   </div>
//                 )
//               } else {
//                 return <CustomInputSearch
//                   key={i.name}
//                   register={register}
//                   name={i.name}
//                   type={i.type}
//                   placeholder={i.labelTitle}

//                 />


//               }
//             })}



//             {cleanEnable &&
//               <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-top">Limpiar búsqueda</Tooltip>}>
//                 <button
//                   id="btnCleanAdvancedSearch"
//                   type='button'
//                   className="btn btn-link color-gray decoration-none d-flex formation-trash-icon"
//                   onClick={handleSubmit(onClean)}
//                 >
//                   <span className="icon-trash">
//                     <i className="bi bi-trash3 outline trashClass"></i>
//                     <i className="bi bi-trash3-fill fill trashClass"></i>
//                   </span>
//                 </button>
//               </OverlayTrigger>
//             }

//             {showSearchBtn && <button
//               type='submit'
//               disabled={!cleanEnable}
//               className="btn-Asearch2 btn btn-success"
//               onClick={() => {
//                 // toggleSearch();
//                 setTimeout(() => {
//                   // window.scrollTo({
//                   //   top: document.body.scrollHeight,
//                   //   behavior: 'smooth'
//                   // })
//                 }, 500);


//               }}
//             >
//               <span>Buscar</span>
//             </button>}


//           </form>

//         </div>
//       }


//     </div>
//   );
// };



import React, { useEffect, useMemo, useRef, useState } from 'react';
import useSearchMember from '../../../../hooks/fetchUsers';
import { Tooltip, OverlayTrigger } from "react-bootstrap";
import { CustomInputSearch } from '../../../dashboard/subContent/searchContainer/CustomInputSearch';
import { AnimatePresence, motion } from 'framer-motion';
import logger from '../../../../utils/logger';
import { useSelector } from 'react-redux';
import { useForm } from 'react-hook-form';
import { MemberService } from '../../../../services/MemberService';

export const ActiveSearchComponent = ({ activeTab, handleData, searchSchema, showSearchBtn, renderUsers, handleFiltered }) => {
  const selectListOptions = useSelector(data => data.commonData.lista.formationPlaces);

  const [isVisible, setIsVisible] = useState(true);
  const [cleanEnable, setCleanEnable] = useState(false);

  const [activeFilter, setActiveFilter] = useState({});

  const { register, handleSubmit, reset, watch } = useForm();
  const allValues = watch();

  logger.debug('allValues: ', allValues)





  logger.debug('renderUsers: ', renderUsers)

  const users = useMemo(() => renderUsers?.items || [], [renderUsers]);

  //?Debounce 

  const [debouncedValues, setDebouncedValues] = useState({})

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedValues(prev => ({
        ...prev,

        name: allValues.name
      }));
    }, 300);

    return () => clearTimeout(timer);
  }, [allValues.name]);




  //?NORMALIZADO
  const normalizeText = (text) =>
    text?.toString()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLowerCase() || "";




  //? Filtrado memorizado
  const filteredUsers = useMemo(() => {
    if (!users.length) return [];

    const isEmpty = Object.values(allValues).every(val => val === "" || val === "0");
    if (isEmpty) return users;

    //? Normalizado el valor del buscador
    const searchName = normalizeText(debouncedValues.name);

    return users.filter(item => {
      const matchesPlace = allValues.formationPlace
        ? item.formationPlace?.id === Number(allValues.formationPlace)
        : true;

      //? Normalizado el nombre del item de la lista
      const itemName = normalizeText(item.name);

      return matchesPlace && itemName.includes(searchName);
    })
  }, [users, allValues, debouncedValues.name])




  //? Enviar al padre solo si cambia realmente
  useEffect(() => {
    handleData(prev => {
      const prevItems = prev?.items || [];
      const areEqual =
        prevItems.length === filteredUsers.length &&
        prevItems.every((u, i) => u.id === filteredUsers[i].id);

      if (!areEqual) {
        logger.debug('Nuevo array filter: ', filteredUsers);


        return { items: filteredUsers };
      }
      return prev;
    });
  }, [filteredUsers, handleData]);


  // 👉 Controla el estado de "hay filtro / no hay filtro"
  useEffect(() => {
    if (filteredUsers.length === 0) {
      handleFiltered(0);
    }
  }, [filteredUsers.length, handleFiltered]);


  //? Control del botón limpiar
  useEffect(() => {
    const hasValues = Object.values(allValues).some(val => val !== "" && val !== "0");
    setCleanEnable(hasValues);
  }, [allValues]);

  const searchRef = useRef(null);

  const toggleSearch = () => setIsVisible(prev => !prev);


  //?Efecto para cerrar el buscador cuando se hace click fuera de el
  useEffect(() => {
    const handleClickOutside = (event) => {
      // if (searchRef.current && !searchRef.current.contains(event.target)) {
      //   setIsVisible(false)
      // }
    };

    document.addEventListener('mousedown', handleClickOutside)

    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [])

  const onSubmit = (data) => {
    logger.info('data: ', data);
  };


  // const getEmptyValues = () =>
  //   Object.fromEntries(
  //     Object.keys(searchSchema).map(key => [key, key === "FormationPlaceId" ? "0" : ""])
  //   );

  const getEmptyValues = () =>
    Object.fromEntries(
      searchSchema.map(field => [
        field.name,
        field.select === "FormationPlaceId" ? "0" : ""
      ])
    );


  useEffect(() => {
    logger.debug("Borrando")
    reset(getEmptyValues());

  }, [activeTab]);



  const onClean = () => {
    reset(getEmptyValues());
  };



  // const onClean = (data) => {
  //   const emptyValues = Object.fromEntries(
  //     Object.keys(data).map(key => [key, key === "FormationPlaceId" ? "0" : ""])
  //   );
  //   reset(emptyValues);
  // };




  return (
    <div className={`search active-search-container ${isVisible && 'searchMobileStyle'}`} ref={searchRef}>
      <div className="buttons-searchers-containers d-flex">
        {cleanEnable && !isVisible &&
          <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-top">Limpiar búsqueda</Tooltip>}>
            <button
              id="btnCleanAdvancedSearch"
              type='button'
              className="btn btn-link color-gray decoration-none d-flex align-items-center me-2 query-margin"
              onClick={handleSubmit(onClean)}
            >
              <span className="icon-trash">
                <i className="bi bi-trash3 outline trashClass"></i>
                <i className="bi bi-trash3-fill fill trashClass"></i>
              </span>
            </button>
          </OverlayTrigger>
        }

        {/* <div className="btn-Asearch">
          <div className='advanced-search-container d-flex p-2' onClick={toggleSearch}>
            <span>Busqueda Avanzada</span>
            <span className={`material-symbols-outlined mI-arrow ${isVisible && 'arrow-subClass'}`}>
              keyboard_double_arrow_up
            </span>
          </div>
        </div> */}
      </div>


      {isVisible &&
        <div className="d-flex w-100">
          <form
            className="aSearch-container formation-search-form"
            onSubmit={handleSubmit(onSubmit)}
            onKeyDown={(e) => {
              //👉 Si el usuario presiona Enter en cualquier input, select, react-select, creatable, etc → NO envía el formulario
              //👉 Enter en textarea sí funciona por los saltos de línea
              if (e.key === "Enter") {
                e.preventDefault();
              }
            }}
          >



            {searchSchema && searchSchema.map((i) => {


              if (i.hasOwnProperty("select") && i.select === 'true') {
                return (selectListOptions && selectListOptions.length > 0 &&

                  <div className="form-floating form-aSearch" key={i.id}>

                    <select
                      {...register(i.name)}
                      id={i.name}
                      name={i.name}
                      className="form-select pt-0 formation-selects"
                      defaultValue=""
                    >

                      <option value="" disabled hidden>
                        Selecciona una opción
                      </option>

                      {selectListOptions.map((option, index) => {

                        return <option key={index} value={option.id}> {option.name}</option>
                      })

                      }
                    </select>

                    <label className="label-fButtons" htmlFor={i.name}>{i.labelTitle}</label>
                  </div>
                )
              } else {
                return <CustomInputSearch
                  key={i.name}
                  register={register}
                  name={i.name}
                  type={i.type}
                  placeholder={i.labelTitle}

                />


              }
            })}



            {cleanEnable &&
              <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-top">Limpiar búsqueda</Tooltip>}>
                <button
                  id="btnCleanAdvancedSearch"
                  type='button'
                  className="btn btn-link color-gray decoration-none d-flex formation-trash-icon"
                  onClick={handleSubmit(onClean)}
                >
                  <span className="icon-trash">
                    <i className="bi bi-trash3 outline trashClass"></i>
                    <i className="bi bi-trash3-fill fill trashClass"></i>
                  </span>
                </button>
              </OverlayTrigger>
            }

            {showSearchBtn && <button
              type='submit'
              disabled={!cleanEnable}
              className="btn-Asearch2 btn btn-success"
              onClick={() => {
                // toggleSearch();
                setTimeout(() => {
                  // window.scrollTo({
                  //   top: document.body.scrollHeight,
                  //   behavior: 'smooth'
                  // })
                }, 500);


              }}
            >
              <span>Buscar</span>
            </button>}


          </form>

        </div>
      }


    </div>
  );
};
